import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationLocationAamsConstants {
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static AREA_OF_DISPLAY_FORM_CONTROL_NAME = "areaOfDisplay";
    static STREET_NAMES_FORM_CONTROL = "streetNames";
    static PROPERTY_DESCRIPTION_FORM_CONTROL_NAME = "propertyDescription";
    static ADDRESS_OR_STREET_FORM_CONTROL_NAME = "addressStreetInformation";
    static AREA_OF_CONTROL_LABEL = "Area of control";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static STREET_NAMES_LABEL = "Street names";
    static PROPERTY_DESCRIPTION_LABEL = "Property description (If it is a private sale or permanent advertisement)";
    static ADDRESS_OR_STREET_LABEL = "Address / Street information";
    static REMOVE_FEATURE_LABEL = "Remove feature";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_OWNER_ATTRIBUTE = "Some owner attribute(s) is missing on the property owner layer. Please contact your systems administrator.";
    static VALIDATION_MESSAGES = {
        areaOfDisplay: {
            required: `Area of display ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        subdivision: {
            required: `Subdivision ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        streetNames: {
            required: `Street names ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        farmNo: {
            required: `Farm no ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        propertyDescription: {
            required: `Property description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        addressOrStreet: {
            required: `Address ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
    static POLYGON_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            point: false,
            circle: false,
            polyline: false,
            rectangle: false
        },
        selectionTools: {
            "lasso-selection": false,
            "rectangle-selection": false
        }
    };
    static POINT_SKETCH_TOOLS_OPTIONS = {
        createTools: {
            circle: false,
            polygon: false,
            polyline: false,
            rectangle: false
        },
        selectionTools: {
            "lasso-selection": false,
            "rectangle-selection": false
        }
    };
}
